module.exports = __webpack_public_path__ + "static/media/image-card-10.be343db2.png";